<template>
    <div>
        <div class="lb-select" v-click-outside="close">
            <div class="lb-select-input form-control" v-on:click.stop="clickSelector">
                <div class="lb-select-container">
                    <div v-for="(item, i) in selectedItems" :key="i" class="lb-select-item">
                        <div>{{getDisplayText(item)}}</div>
                        <div v-if="multiselect" class="lb_remove" v-on:click.stop="selectItem(item)"><svg version="1.1" role="presentation" width="12.571428571428571" height="16" viewBox="0 0 1408 1792"><path d="M1298 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"></path></svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="selector" v-if="showSelector">
                <div class="selector-container">
                    <ul class="selector-list">
                        <li v-for="(item, i) in list" :key="i" v-on:click="selectItem(item)">{{getDisplayText(item)}}</li>
                    </ul>
                </div>
                <pagination class="mt-1 p-1" v-if="pagination" v-bind:totalCount="totalCount" v-model="pagination" v-on:reload="reload" :search-placeholder="searchPlaceholder" :items-placeholder="itemsPlaceholder"></pagination>
            </div>
        </div>
    </div>
</template>

<style scoped="">

    .lb-select {
        position: relative;
    }

    .lb-select .lb-select-input {
        overflow-x: auto;
        overflow-y: hidden;
        width: 100%;
        position: relative;
    }

    .lb-select .lb-select-input .lb-select-container {
        display: flex; /*added*/
        flex-direction: row; /*added*/
        white-space: nowrap;
    }

    .lb-select .lb-select-input .lb-select-item {
        border-radius: 2px;
        background-color: #004b64;
        color: #fff;
        padding: 0 2px;
        fill: #fff;
        margin-right: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .lb-select .lb-select-input .lb-select-item > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .lb-select .lb-select-input .lb-select-item .lb_remove {
        margin: 0 2px;
    }

    .lb-select .selector {
        position: absolute;
        top: calc(1.95rem + 2px);
        left: 0px;
        border: 1px solid #e4e6eb;
        background-color: #fff;
        z-index: 10;
        width: 100%;
    }

    .lb-select .selector .selector-container {
        max-height: 300px;
        overflow: auto;
    }

    .lb-select .selector .selector-list {
        list-style: none;
        margin: 0px;
        padding: 0px;
        width: 100%;
    }

    .lb-select .selector .selector-list li {
        list-style: none;
        margin: 0px;
        padding: 10px;
        width: 100%;
        border-bottom: 1px solid #e4e6eb;
    }

    .lb-select .pagination-container {
        padding: 5px;
    }

</style>

<script>

import ClickOutside from 'vue-click-outside'
import Pagination from 'lb-vue-pagination'

export default
{
    name: 'LbSelect',
    props: ['value', 'list', 'pagination', 'displayField', 'displayFunc', 'valueField', 'multiselect', 'empty', 'searchPlaceholder', 'itemsPlaceholder', 'totalCount'],
    data()
    {
        return {
            showSelector: false,
            selectedItems: []
        }
    },
    directives: {
        'click-outside': ClickOutside
    },
    components:
    {
      pagination: Pagination
    },
    created()
    {
        var me = this;

        me.fillInitialValue();
    },
    methods:
    {
        clickSelector()
        {
            var me = this;

            me.$emit('click');

            me.showSelector = !me.showSelector;
        },
        close()
        {
            var me = this;
            me.showSelector = false;
        },
        reload()
        {
            var me = this;

            me.$emit('reload');
        },
        getDisplayText(item)
        {
            var me = this;

            if (me.displayFunc != undefined) return me.displayFunc(item);

            return item[me.getDisplayField];
        },
        selectItem(item)
        {
            var me = this;

            var index = me.selectedItems.indexOf(item);

            if(me.multiselect)
            {
                if(index == -1) me.selectedItems.push(item);
                else me.selectedItems.splice(index, 1);
            }
            else
            {
                if(me.empty)
                {
                    if(index != -1) me.selectedItems.splice(0);
                    else
                    {
                        me.selectedItems.splice(0);
                        me.selectedItems.push(item);
                    }
                }
                else
                {
                    me.selectedItems.splice(0);
                    me.selectedItems.push(item);
                }
            }


            var valueArr = [];

            for(var val of me.selectedItems)
            {
                valueArr.push(val[me.getValueField]);
            }

            me.$emit('change', valueArr.join(','));

            me.$emit('input', valueArr.join(','));
        },
        fillInitialValue()
        {
            var me = this;

            me.selectedItems = [];

            if(me.list == undefined)
            {
                return;
            }

            if(me.list.length == undefined)
            {
                console.error('lb-vue-select: List is not an array')
            }

            if(me.value == undefined || me.value == null) return;

            var isNumber = false,
                tempValue = me.value;

            if(typeof tempValue == 'number')
            {
                tempValue = tempValue.toString();
                isNumber = true;
            }

            var valueArr = tempValue.split(',');

            for(var val of valueArr)
            {
                if(val == '') continue;
                if(isNumber)
                {
                    val = parseInt(val);
                }
                var foundInList = false;
                for(var item of me.list)
                {
                    if(item[me.getValueField] == val)
                    {
                        foundInList = true;
                        var found = false;
                        for(var sel of me.selectedItems)
                        {
                            if(sel[me.getValueField] == val) found = true;
                        }
                        if(!found) me.selectedItems.push(item);
                    }
                }

                if(!foundInList && me.pagination != undefined)
                {
                  if(typeof me.multiselect !== 'undefined')
                  {
                    if(!me.pagination.initialId.includes(val))
                    {
                      me.pagination.initialId.push(val);
                    }
                  }
                  else
                  {
                    me.pagination.initialId.splice(0);
                    me.pagination.initialId.push(val);
                  }
                }
            }
        }
    },
    computed:
    {
        displayValue()
        {
            var me = this;

            me.setInitialId();

            return me.value;
        },
        getValueField()
        {
            var me = this;

            if(me.valueField == undefined) return 'value';
            return me.valueField;
        },
        getDisplayField()
        {
            var me = this;

            if(me.displayField == undefined) return 'key';
            return me.displayField;
        }
    },
    watch:
    {
        value()
        {
            var me = this;

            me.fillInitialValue();
        },
        list:
        {
            handler()
            {
                var me = this;

                me.fillInitialValue();
            },
            deep: true
        },
        pagination:
        {
            handler()
            {
                var me = this;
                me.$emit('reload', null);
            },
            deep: true
        }
    }
}
</script>
